export default __webpack_public_path__ + "assets/25070c542198f12ed2a92226573cb1de.woff";